import type { TISODateTime } from '@/infra/types/common';

const getTimeValue = (datetime: Date | number | TISODateTime): number =>
  typeof datetime === 'number' ? datetime : (datetime instanceof Date ? datetime : new Date(datetime)).getTime();

export default getTimeValue;
